export const DEFAULT_ALERT_LEAD = { days7: 7, days15: 15, days30: 30 };

export function validateAlertLead(value) {
  const values = Object.keys(DEFAULT_ALERT_LEAD).map((key) => {
    const raw = value?.[key];
    if ((typeof raw !== "number" && typeof raw !== "string") || String(raw).trim() === "") {
      throw new Error("Compila tutte le soglie con giorni interi non negativi.");
    }
    const number = Number(raw);
    if (!Number.isSafeInteger(number) || number < 0) {
      throw new Error("Le soglie devono essere giorni interi non negativi.");
    }
    return number;
  });
  if (!(values[0] < values[1] && values[1] < values[2])) {
    throw new Error("Le tre soglie devono essere in ordine crescente, dalla prima alla terza.");
  }
  return Object.fromEntries(Object.keys(DEFAULT_ALERT_LEAD).map((key, index) => [key, values[index]]));
}
